export default __webpack_public_path__ + "static/media/TRX.634c4fd2.jpg";